import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import axios from 'axios';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

axios.defaults.baseURL = 'http://nueva.catabocata.com:9649';
//axios.defaults.baseURL = 'http://192.168.1.66:9649';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
